<template>
  <div>
    <el-row>
      <el-col v-if="title" :sm="24" :md="12" :lg="12">
        <component :is="titleHeading"><i class="fa fa-paperclip">&nbsp;</i>{{title}}</component>
      </el-col>

      <el-col align="right" :sm="16" :md="8" :lg="title ? 10 : 22">
        There <span>{{files.length === 1 ? 'is' : 'are'}}</span>
        <b :key="files.length">{{files.length}}</b>/{{this.maxFiles}}
        <span>{{files.length === 1 ? 'file' : 'files'}}</span>
        for this {{this.process ? this.process : this.type}}.
      </el-col>


      <el-col align="right" :sm="6" :md="4" :lg="2">

        <file-upload
          v-if="files.length < maxFiles && isTowerCo()"
          :url="uploadUrl"
          :text="'Upload (' + (this.maxFiles - this.files.length) + ')'"
          :model="uploads" list-type="text"
          :wrap-form-item="false"
          :show-delete="false"
          :after-upload="showSuccess"
          :disabled="disabled || readOnly" />
        </el-col>
      </el-row>

      <el-row>

        <div v-if="files.length === 0">
          <dropzone v-if="!disabled && !readOnly"
          :ref="thisRef + 'Ref'"
          :id="thisRef"
          :use-font-awesome="true"
          :auto-process-queue="false"
          :maxFileSizeInMB="8"
          :default-message="uploadMessage"
          :headers="options.headers"
          @vdropzone-file-added="onFileAdded"
          @vdropzone-success="showSuccess"
          @vdropzone-error="onError"
          :options="options">
          <!-- Optional parameters if any! -->
          <input type="hidden" name="token" value="xxx123">
        </dropzone>

      </div>


      <div v-else>

        <el-col :span="24" v-if="!hideCarousel">
          <br />

          <vue-flux
           :images="images"
           :transitions="trans"
           :captions="captions">

            <template v-slot:caption>
              <flux-caption />
            </template>

            <template v-slot:preloader>
              <flux-preloader />
            </template>

            <template v-slot:pagination>
              <flux-pagination />
            </template>

            <template v-slot:controls>
              <flux-controls />
            </template>

            <template v-slot:index>
              <flux-index />
            </template>

        </vue-flux>
        </el-col>
      </div>
    </el-row>

    <el-table v-if="files.length > 0" :data="files" stripe size="mini">

      <el-table-column prop="name" label="File Name" :width="isDesktop ? 528 : 396">
        <template slot-scope="scope">
          <i :class="'fa fa-' + (isPDF(scope.row.mimeType) ? 'file-pdf text-danger' : 'image text-primary')">&nbsp;</i><b>{{scope.row.name}}</b>
          <i class="hidden-md-and-down">&nbsp;{{formatNumber(scope.row.size ? scope.row.size/1000 : 0)}}k.</i>
        </template>
      </el-table-column>

      <el-table-column class-name="hidden-sm-and-down">
        <template slot-scope="scope">
          <center><el-button type="text" icon="fa fa-eye" @click="view(scope.row)" /></center>
        </template>
      </el-table-column>


      <el-table-column v-if="!readOnly" class-name="hidden-md-and-down">
        <template slot-scope="scope">
          <strong>
            <a class="el-button" :href="getEndpoint('/file/download/'+ scope.row.url  + '/' + profile().name)"
            :download="scope.row.name">
            <i class="fa fa-cloud-download-alt"></i></a>
          </strong>
        </template>
      </el-table-column>

      <el-table-column>
        <template slot-scope="scope">
          <el-button v-if="isManager()" type="danger" @click="deleteFile(scope.row.id, scope.row.name)" icon="fa fa-trash-alt" circle :disabled="disabled" />
        </template>
      </el-table-column>


      <el-table-column class-name="hidden-md-and-down" prop="upload_at" label="Uploaded" width="285">
        <template slot-scope="scope">
              <i class="fa fa-clock"></i>
              <span style="margin-left: 10px">{{ formatDateTime(scope.row.upload_at) }}</span>
        </template>
      </el-table-column>


    </el-table>




    <!-- Popup -->
    <el-dialog v-if="file"
      :title="file.name"
      :visible.sync="isViewer"
      width="80%"
      height="80%"
      center>

      <div style="overflow: auto;">
        <pdf-viewer v-if="isPDF(file.mimeType)" :url="getEndpoint('/file/view/' + file.url)" />
        <progressive-img v-else width="100%" height="auto" :src="getEndpoint('/file/view/' + file.url)" />
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button type="plain" @click="isViewer = false">Close</el-button>
      </span>
    </el-dialog>


  </div>
</template>


<script>

import ArrayMixins from '@/mixins/ArrayMixins'
import DateMixins from '@/mixins/DateMixins'
import NumberMixins from '@/mixins/NumberMixins'
import PostMixins from '@/mixins/PostMixins'

import Dropzone from 'vue2-dropzone'

import FileUpload from '@/components/atoms/files/FileUpload'
import PdfViewer from '@/components/atoms/PdfViewer'
import axios from '@/lib/axiosClient'

// import FilesPagination from '@/components/atoms/files/FilesPagination'

import {
   VueFlux,
   FluxCaption,
   FluxControls,
   FluxIndex,
   FluxPagination,
   FluxPreloader
} from 'vue-flux'

import 'vue2-dropzone/dist/vue2Dropzone.min.css'

export default {
  name: 'files-panel',

  mixins: [ArrayMixins, DateMixins, PostMixins, NumberMixins],

  components: {
    Dropzone,
    FileUpload,
    PdfViewer,
    VueFlux,
    FluxCaption,
    FluxControls,
    FluxIndex,
    FluxPagination,
    FluxPreloader
  },

  props: {

    title: {
      type: String,
      default: null
    },

    titleHeading: {
      type: String,
      default: 'h3'
    },

    type: {
      type: String,
      required: true
    },

    id: {
      type: [String, Number],
      required: true
    },

    process: {
      type: String,
      default: null
    },

    processId: {
      type: [String, Number],
      default: null
    },

    stepNo: {
      type: [String, Number],
      default: null
    },

    partyNo: {
      type: [String, Number],
      default: null
    },

    maxFiles: {
      type: Number,
      default: 10
    },

    hideCarousel: {
      type: Boolean,
      default: false
    },

    readOnly: {
      type: Boolean,
      default: false
    },

    disabled: {
      type: Boolean,
      default: false
    },

    uploadMessage: {   // TODO not being passed to dropzone...
      type: String,
      default: 'Drop files here to upload'
    }
  },



  computed: {

    uploadUrl: function () {
      return this.getEndpoint('/file/upload/' + this.urlSuffix())
    },

    filesUrl: function () {
      return '/files/' + this.urlSuffix()
    }

  },


  methods: {


    refresh () {
      this.fetchData(this.filesUrl, this.fetchFiles)
    },


    isImage (type) {
      return type && type.toLowerCase().startsWith('image')
    },


    isPDF (type) {
      return type && type.toLowerCase().endsWith('pdf')
    },


    urlSuffix () {
      return this.type.toLowerCase().trim() + '/' +
        this.id + (this.process && this.processId
          ? '/' + this.process.toLowerCase() + '/' + this.processId : '') // @TODO + '/' + this.userName()
/*
          (this.stepNo ? '/' + this.stepNo : '/null') +
          '/null/null/' + this.userName()
*/
    },


    showSuccess (file) {
      this.refresh()
    },


    onError (file) {
      console.error('Error on uploading file:', file)
      this.$message.error('Unable to upload file ' + file)
    },

    async onFileAdded (file) {
      const formData = new FormData()
      formData.append('file', file)

      try {
        // Manually remove file from dropzone UI after success if needed,
        // or just let the refresh handle it.
        if (this.$refs[this.thisRef + 'Ref']) {
          this.$refs[this.thisRef + 'Ref'].removeFile(file)
        }

        const response = await axios.post(this.uploadUrl, formData, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        })
        this.showSuccess(response.data)
      } catch (error) {
        this.onError(file)
      }
    },


    caption (item) {

      if (item) {
        if (item.caption) {
          return item.caption
        }

        if (item.title !== item.name) {
          return (item.title ? item.title + ': ' : '') + item.name
        } else {
          return item.name
        }
      } else {
        return 'No file information found'
      }

    },

    fetchFiles (results) {

      this.file = null
      this.files = []
      this.uploads = []
      this.images = []
      this.captions = []

      this.files = results

      for (let i = 0; i < this.files.length; i++) {
        let item = this.files[i]

        if (this.isPDF(item.mimeType) || this.isImage(item.mimeType)) {

          if (this.isPDF(item.mimeType)) {
            this.images.push('static/pdf.png')
            this.captions.push(this.caption(this.files[i]))
          } else {
            this.images.push(this.getEndpoint('/file/view/' + item.url, null, false))
            this.captions.push(this.caption(this.files[i]))
          }

        } // if isPDF or isImage

      } // for

    },


    view (file) {
      this.file = file
      this.isViewer = !this.isViewer
    },


    deleted (data) {
      this.arrayRemoveById(this.files, 'id', data.id)
      this.refresh()
    },


    deleteFile (id, file) {
      this.deleteItem(this, id, '/file', file, this.deleted)
    }

  },



  data () {

    return {
      visible: false,
      isViewer: false,
      thisRef: this.type.toLowerCase() + '-uploader',
      localData: this.rowData,
      localType: this.type.toLowerCase().trim(),
      dialogImageUrl: '',
      dialogVisible: false,
      images: [],
      captions: [],
      trans: ['waterfall', 'slide', 'blocks1', 'wave', 'blocks2', 'blinds3d', 'round1', 'round2', 'cube'],
      files: [],
      uploads: [],
      file: null,
      options: {
        url: this.uploadUrl,
        thumbWidth: 150,
        headers: {
          'Access-Control-Allow-Origin': this.uploadUrl,
          'Access-Control-Allow-Methods': 'GET, POST, OPTIONS, PUT, DELETE',
          'Access-Control-Allow-Headers': 'Origin, X-Requested-With, Content-Type, Accept, X-File-Name, X-File-Size, X-File-Type'
        }
      }
    }
  },

  beforeMount () {
    this.options.url = this.uploadUrl
//    this.options.headers.'Access-Control-Allow-Origin' = this.uploadUrl
  },

  created () {
    this.fetchData(this.filesUrl, this.fetchFiles)
  }
}
</script>


<style scoped>

a {text-decoration: none;}

</style>
